var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c, _d, _e, _f, _g, _h;
import { makeObservable, observable, runInAction } from 'mobx';
import { BaseSingletonService, Singleton } from './service.base';
import { MediaSearchService } from './service.media.search';
import { TabsService } from './servive.tabs';
import { EApiUrl } from '~/tools/api/types';
import { ServiceFile } from '~/services/service.file';
import { EFileSize, EFileType, FILE_WITH_COPYRIGHT_PREFIX } from '~/shared/types/file';
import { EFilterType } from '~/shared/types/filter';
import { MobxQuery } from '~/tools/mobx.query';
import { api } from '~/tools/api';
import { UIOpenService } from '~/services/service.ui';
import { ServiceCommunity } from '~/services/service.community';
import { getFileExtension, getFileLink } from '~/tools/file';
import { ServiceConfig } from '~/services/service.config';
import { AuthService } from '~/services/service.auth';
export let RecentService = class RecentService extends BaseSingletonService {
    filterSvc;
    mediaSearchSvc;
    fileService;
    openService;
    communityService;
    serviceConfig;
    authService;
    items = [];
    communityId;
    filterType = EFilterType.all;
    constructor(filterSvc, mediaSearchSvc, fileService, openService, communityService, serviceConfig, authService) {
        super();
        this.filterSvc = filterSvc;
        this.mediaSearchSvc = mediaSearchSvc;
        this.fileService = fileService;
        this.openService = openService;
        this.communityService = communityService;
        this.serviceConfig = serviceConfig;
        this.authService = authService;
        makeObservable(this);
        this.setCommunityId(communityService.currentCommunity.id);
        this.getRecentItems();
    }
    get lastItemId() {
        return Number.parseInt(this.items[this.items.length - 1]?.id) || 0;
    }
    getItems(data) {
        return data?.map(item => ({
            img: this.fileService.getThumbnailLink(EFileSize.small, false, item),
            title: item.description,
            fileType: item.obj_type,
            extension: item.file_extension,
            depository: item.depository,
            id: item.id,
            name: item.name,
            date: item.date,
            eventLocation: item.location || '',
            author: item.author,
            physicalForm: item.physical_form_description,
            userId: item.user_id,
            physicalFormCode: item.physical_form_code,
            fileLink: getFileLink(`${item.obj_type === EFileType.image
                ? item.path + '_' + EFileSize.large + FILE_WITH_COPYRIGHT_PREFIX
                : item.path || ''}`, this.serviceConfig.awsUrl, getFileExtension(item.obj_type, item.file_extension), item.obj_type),
        }));
    }
    setCommunityId(communityId) {
        this.communityId = communityId;
    }
    setFilterType(filterType) {
        this.filterType = filterType;
    }
    getRecentItems() {
        return new MobxQuery({
            queryFn: (() => api
                .get(`${EApiUrl.communities}/${this.communityId}/latest`, {
                params: {
                    regUser: this.authService.isLogged,
                    type: this.filterType,
                },
            })
                .then(response => {
                runInAction(() => (this.items = this.getItems(response.data?.collection) || []));
            })),
        }).query();
    }
};
__decorate([
    observable,
    __metadata("design:type", typeof (_h = typeof Array !== "undefined" && Array) === "function" ? _h : Object)
], RecentService.prototype, "items", void 0);
RecentService = __decorate([
    Singleton(),
    __metadata("design:paramtypes", [typeof (_a = typeof TabsService !== "undefined" && TabsService) === "function" ? _a : Object, typeof (_b = typeof MediaSearchService !== "undefined" && MediaSearchService) === "function" ? _b : Object, typeof (_c = typeof ServiceFile !== "undefined" && ServiceFile) === "function" ? _c : Object, typeof (_d = typeof UIOpenService !== "undefined" && UIOpenService) === "function" ? _d : Object, typeof (_e = typeof ServiceCommunity !== "undefined" && ServiceCommunity) === "function" ? _e : Object, typeof (_f = typeof ServiceConfig !== "undefined" && ServiceConfig) === "function" ? _f : Object, typeof (_g = typeof AuthService !== "undefined" && AuthService) === "function" ? _g : Object])
], RecentService);
